import type { ButtonProps } from '@components/button/button.view';
import Button from '@components/button/button.view';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
import { validateString } from 'utils/validate-string';

import styles from './icon-button.module.scss';

interface IconButtonProps extends ButtonProps {
  readonly circle?: boolean | undefined;
}

const rootClass = validateString(styles.root);
const circleClass = validateString(styles.circle);

function IconButton({
  className,
  children,
  circle,
  variant = 'text',
  ...buttonProps
}: IconButtonProps): ReactElement {
  return (
    <Button
      className={classNames(rootClass, className, {
        [circleClass]: circle,
      })}
      {...buttonProps}
      variant={variant}
    >
      {children}
    </Button>
  );
}

export default IconButton;
